
namespace TabAurous.ProductDevelopment {

    @Serenity.Decorators.registerClass()
    export class CustomerRequirementBOMGrid extends Serenity.EntityGrid<CustomerRequirementBOMRow, any> {
        protected getColumnsKey() { return 'ProductDevelopment.CustomerRequirementBOM'; }
        protected getDialogType() { return CustomerRequirementBOMDialog; }
        protected getIdProperty() { return CustomerRequirementBOMRow.idProperty; }
        protected getInsertPermission() { return CustomerRequirementBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return CustomerRequirementBOMRow.localTextPrefix; }
        protected getService() { return CustomerRequirementBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}